<template>
  <wdw-dynbox :title="domainStore.translate('user.profile.menu-item.edit-details')">
    <Form @submit="onSubmitEditProfileForm">
      <div id="wdw-editprofile-form" class="wdw-form">
        <form-control-input
          :label="domainStore.translate('user.form.label.displayname')"
          type="text"
          name="displayname"
          code="displayname"
          :serverError="data.errors['displayname']"
          :required="toBool(1, true)"
          :public="toBool(1, true)"
          :hidden="toBool(0, false)"
          :help="domainStore.translate('user.form.message.displayname-help')"
          parentFormId="wdw-editprofile-form"
          :defaultvalue="user.public_name"
        />
        <fieldset v-if="attribute_fields.length > 0">
          <form-control-attributes
            :fields="attribute_fields"
            :serverErrors="data.errors"
            :initialValues="data.initial_values"
            parentFormId="wdw-editprofile-form"
          />
        </fieldset>
        <p />
        <button type="submit" class="btn btn-primary btn-form-submit" :disabled="data.loading" name="submit">
          {{ domainStore.translate('user.profile.displayname.submit') }}
        </button>
        &nbsp;
        <button
          type="button"
          class="btn btn-default btn-form-cancel"
          :disabled="data.loading"
          name="cancel"
          @click="emitClose()"
        >
          {{ domainStore.translate('user.form.cancel') }}
        </button>
        <vue-loading v-if="data.loading" />
      </div>
    </Form>
  </wdw-dynbox>
</template>

<script>
import { userStore } from '@/store/user-store';
import { domainStore } from '@/store/domain-store';
import useConverter from '@/composables/general/useConverter';
import { onMounted, reactive, computed, ref } from 'vue';
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import { RepositoryFactory } from '@/api/repositoryFactory';

import { Form } from 'vee-validate';
import VueLoading from '@/components/general/Loading';
import FormControlInput from '@/components/general/FormControl/Input';
import FormControlAttributes from '@/components/general/FormControl/Attributes';
import { domain } from '@/composables/general/useDomainSettings';

const UserRepository = RepositoryFactory.get('user');
const DomainRepository = RepositoryFactory.get('domain');

export default {
  name: 'profile',

  props: {
    attribute_fields: {
      type: Number,
      required: true,
    },
  },
  emits: ['close'],

  setup(props, context) {
    const data = reactive({
      // Server-related errors
      errors: {},
      //show loading view
      loading: false,
      // Attributes for profile
      initial_values: {},
    });
    const { toBool } = useConverter();

    //+---------------------+
    //|   computed          |
    //+---------------------+

    const user = computed(() => {
      return userStore.getState().user;
    });

    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });

    //+--------------------+
    //|    Methods         |
    //+--------------------+

    function emitClose(message) {
      context.emit('close', message);
    }
    const onSubmitEditProfileForm = (values, actions) => {
      data.loading = true;
      data.errors = [];

      UserRepository.putProfile(user.value.id, values)
        .then(resp => {
          data.loading = false;
          userStore.fetchUser(true);
          emitClose(domainStore.translate('user.profile.displayname.success'));
        })
        .catch(err => {
          data.loading = false;
          data.errors['displayname'] = domainStore.translate('user.profile.displayname.error');
        });
    };

    // TODO
    // get set profile attributes values correctly (server)
    // even when not public?

    // if(user.value.attributes && user.value.attributes.length > 0){
    //   data.attribute_fields.forEach(f => {
    //     let found = false;
    //     user.value.attributes.forEach(attr_val => {
    //       if(fetch.code == attr_val.code){
    //         data.initial_values["attribute-" + f.id] = user.value[f.code];
    //         found = true;
    //       }
    //     });
    //     if(!found){
    //       data.initial_values["attribute-" + f.id] = "";
    //     }
    //   });
    // }

    return {
      // ---VARIABLE---
      domainStore,
      // Computed methods
      user,
      // Listeners
      onSubmitEditProfileForm,
      emitClose,
      // Other
      toBool,
      data,
    };
  },

  components: {
    WdwDynbox,
    Form,
    FormControlInput,
    FormControlAttributes,
    VueLoading,
  },
};
</script>
